export const LAST_ACTIVITY_KEY = 'session.lastActivity';
export const LOGOUT_KEY = 'session.forceLogout';
export const COUNTDOWN_START_KEY = 'session.countdownStart';
